import React from 'react'
import styled from 'styled-components'
import { layoutMaxSize, ZIndex } from 'src/styles/mixin'
import Button, { ButtonOption3 } from 'src/components/common/Button'
import { Container } from 'src/components/common/Container'
import { Noto_body1_b16, Noto_body2_m14, Noto_body2_r14 } from 'src/styles/fonts/NotoSansKrFonts'
import { Typography } from 'src/components/common/Typography'
import { Divider, SmallDivider } from 'src/components/common/Divider'
import { Icon } from 'src/assets/svg/Icon'
import { useFormContext } from 'react-hook-form'
import { GiftSendFormItemsType } from 'src/types/react-hook-form'
import GiftSendInfo from 'src/pages/GiftSendPage/_components/GiftSendInfo'
import GiftSendMsgCard from 'src/pages/GiftSendPage/_components/GiftSendMsgCard'
import { GiftOnlySendPageProps } from 'src/pages/GiftSendPage/GiftOnlySendPage/index'
import RenderIf from 'src/components/common/RenderIf'
import { CouponDetailCard } from 'src/components/common/CouponDetailCardItems'
import Skeleton from 'react-loading-skeleton'
import { getBrandAndCouponName } from 'src/utils'

const GiftOnlySendView = (props: GiftOnlySendPageProps) => {
  const { purchaseHistoryDetailData, purchaseHistoryDetailDataList, handleGiftSendSubmit } = props
  const { formState } = useFormContext<GiftSendFormItemsType>()
  const { isValid } = formState
  const { CouponName } = purchaseHistoryDetailData!

  return (
    <S.GiftOnlySend.Container $option="flex_column">
      {/*받는 사람 정보*/}
      <GiftSendInfo {...props} />
      <Divider />
      {/*메시지 카드*/}
      <GiftSendMsgCard {...props} />
      <Divider />
      <S.GiftOnlySend.Middle.Container>
        <S.GiftOnlySend.CouponInfo.Container $option="flex_column">
          <Typography $fontStyle={Noto_body2_m14} $color="var(--black-50)">
            {getBrandAndCouponName(CouponName)?.brandName}
          </Typography>
          <Typography $fontStyle={Noto_body1_b16} $color="var(--black-90)">
            {getBrandAndCouponName(CouponName)?.couponName}
          </Typography>
        </S.GiftOnlySend.CouponInfo.Container>
      </S.GiftOnlySend.Middle.Container>
      <CouponDetailCard.DetailInfoList>
        {purchaseHistoryDetailDataList?.map(
          (ele: { text: string; value: string } | null, index: number) => (
            <RenderIf when={!!ele?.text} key={index}>
              <CouponDetailCard.DetailInfoLine
                key={index}
                $disabled={!ele}
                as={ele?.value !== '' || !!ele?.value ? 'div' : Skeleton}
              >
                <CouponDetailCard.DetailTitle>{ele?.text}</CouponDetailCard.DetailTitle>
                <CouponDetailCard.DetailDesc>{ele?.value}</CouponDetailCard.DetailDesc>
              </CouponDetailCard.DetailInfoLine>
            </RenderIf>
          ),
        )}
      </CouponDetailCard.DetailInfoList>
      <SmallDivider />
      <S.GiftOnlySend.Bottom.Container>
        {/*주의사항*/}
        <S.GiftOnlySend.Noti.Container $option="flex_row" $column_gap="14px">
          <S.GiftOnlySend.Noti.Icon>
            <Icon.RedNoti />
          </S.GiftOnlySend.Noti.Icon>
          <Typography $fontStyle={Noto_body2_r14} $color="var(--black-70)">
            수신인을 잘못 지정하여 다른 사람이 사용한 경우 책임은 사용자에게 있으며, 환불되지
            않습니다.
          </Typography>
        </S.GiftOnlySend.Noti.Container>
      </S.GiftOnlySend.Bottom.Container>
      <S.GiftOnlySend.Fixed.Container $option="flex_row">
        <Button
          option={ButtonOption3('active')}
          onClickFn={handleGiftSendSubmit}
          disabled={!isValid}
        >
          선물 발송하기
        </Button>
      </S.GiftOnlySend.Fixed.Container>
    </S.GiftOnlySend.Container>
  )
}
export default GiftOnlySendView

const S = {
  GiftOnlySend: {
    Container: styled(Container)``,
    Middle: {
      Container: styled(Container)`
        padding: 20px 20px 0 20px;
      `,
    },
    Bottom: {
      Container: styled(Container)`
        padding: 30px 20px 100px;
      `,
    },
    CouponInfo: {
      Container: styled(Container)`
        display: flex;
        padding: 16px;
        border-radius: 12px;
        background-color: var(--black-2);
      `,
    },
    Noti: {
      Container: styled(Container)`
        display: grid;
        grid-template-columns: 30px 1fr;
        align-items: center;
        padding: 16px;
        border-radius: 12px;
        background-color: var(--red-5);
      `,
      Icon: styled(Container)`
        display: flex;
        justify-content: center;
        align-items: center;
        width: 30px;
        height: 30px;
        border-radius: 50%;
        background-color: var(--red-20);
      `,
    },
    Fixed: {
      Container: styled(Container)`
        ${layoutMaxSize};
        position: fixed;
        left: 50%;
        bottom: 0;
        padding: 10px;
        border-top: 1px solid var(--black-4);
        background-color: var(--white);
        transform: translate(-50%, 0%);
        z-index: ${ZIndex.BottomFixedContents};
      `,
    },
  },
}
